import React, { memo, useRef } from 'react';
import FormattedHtml from 'components/common/FormattedHtml';
import { makeStyles } from 'tss-react/mui';

interface IProps {
  description: string;
  variant?: string;
}

const useStyles = makeStyles()((theme) => ({
  main: {
    padding: theme.spacing(3, 4),
    backgroundColor: theme.palette.background.default,
    borderRadius: 8,
  },
}));

/* eslint-disable react/no-danger */
const EventFooterDescription: React.FC<IProps> = ({ description, variant = 'body1' }) => {
  const ref: any = useRef<HTMLDivElement>(null);
  const { classes } = useStyles();

  return (
    <div className={classes.main}>
      <FormattedHtml content={description} ref={ref} variant={variant} />
    </div>
  );
};

export default memo(EventFooterDescription);
